import { observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import SideControlsPage from "../../Layouts/SideControls/SideControlsPage";
import { MAIN_APP_BAR_HEIGHT_PX } from "components/Navigation/appBarHeight";
import { useStore } from "../../utils/useStore";
import { ManagerInteractionsDashboardStore } from "./Stores/ManagerInteractionsDashboardStore";
import ManagerInteractionNavigation from "./Views/ManagerInteractionNavigation";
import ManagerInteractionRoutes from "./Views/ManagerInteractionRoutes";

interface OwnProps {}

type Props = OwnProps;

const ManagerInteractions: FunctionComponent<Props> = observer((props) => {
    const dashboardStore = useStore(ManagerInteractionsDashboardStore);

    return (
        <SideControlsPage
            mainContent={<ManagerInteractionRoutes />}
            enableMinimize={!dashboardStore.isEditMode}
            drawerLocation={"left"}
            drawerContent={<ManagerInteractionNavigation />}
            mainGridSpacing={0}
            mainGridJustify={"flex-start"}
            mainGridAlignItems={"stretch"}
            containerOffsetPixels={MAIN_APP_BAR_HEIGHT_PX}
            drawerVerticalOffsetPixels={0}
        />
    );
});

export default ManagerInteractions;
